
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/excursies",
      function () {
        return require("private-next-pages/excursies/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/excursies"])
      });
    }
  